module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Monitor-and-Screens.1384a090.jpg";